
export const baseUrl = 'https://listingapp.kestatesclients.com';
export const profileImageBaseUrl = 'https://listingapp.kestatesclients.com/public/profile_images';
export const propertyImagesUrl = 'https://listingapp.kestatesclients.com/public/property_images';
export const propertyDocumentsUrl = 'https://listingapp.kestatesclients.com/public/uploads';
export const iconsUrl = 'https://listingapp.kestatesclients.com/public/amenities_icons';
export const signatureImageBaseUrl = "";


// export const baseUrl = 'http://localhost:8000';
// export const profileImageBaseUrl = 'http://localhost:8000/public/profile_images';
// export const propertyImagesUrl = 'http://localhost:8000/public/property_images';
// export const propertyDocumentsUrl = 'http://localhost:8000/public/uploads';
// export const iconsUrl = 'http://localhost:8000/public/amenities_icons';
// export const signatureImageBaseUrl = "";